document.addEventListener('DOMContentLoaded', function () {
  const popupWrap = document.querySelector('.promo-popup-wrap');
  if (!popupWrap) return;

  const form = popupWrap.querySelector('#promo-popup-form');
  const panels = Array.from(popupWrap.querySelectorAll('[data-promo-panel]'));
  const successMarker = popupWrap.querySelector('[data-subscription-success]');
  const errorMarker = popupWrap.querySelector('[data-subscription-error]');

  const STATE_KEY = 'binamPromoState_v2';
  const SESSION_SUBSCRIBED_KEY = 'binamPromoWelcomeSubscribedThisSession';
  const STATE_VERSION = 2;

  const now = Date.now();
  const designMode = popupWrap.dataset.designMode === 'true';
  const previewMode = popupWrap.dataset.previewMode || 'auto';
  const welcomeDelayMs = Number(popupWrap.dataset.welcomeDelay || 12) * 1000;
  const welcomeDismissMs = Number(popupWrap.dataset.welcomeDismissHours || 24) * 60 * 60 * 1000;
  const wholesaleMinMs = Number(popupWrap.dataset.wholesaleMinMinutes || 5) * 60 * 1000;
  const wholesaleMinPages = Number(popupWrap.dataset.wholesaleMinPages || 2);
  const wholesaleDismissMs = Number(popupWrap.dataset.wholesaleDismissDays || 7) * 24 * 60 * 60 * 1000;

  let popupOpenedOnPage = false;
  let activePanel = null;
  let timerId = null;

  function defaultState() {
    return {
      version: STATE_VERSION,
      pageViews: 0,
      welcome: {
        subscribed: false,
        dismissedUntil: 0,
        handledAt: 0,
        handledPageView: 0
      },
      wholesale: {
        completed: false,
        dismissedUntil: 0,
        shownCount: 0
      }
    };
  }

  function loadState() {
    try {
      const parsed = JSON.parse(localStorage.getItem(STATE_KEY) || 'null');
      if (!parsed || parsed.version !== STATE_VERSION) return defaultState();
      return {
        ...defaultState(),
        ...parsed,
        welcome: { ...defaultState().welcome, ...(parsed.welcome || {}) },
        wholesale: { ...defaultState().wholesale, ...(parsed.wholesale || {}) }
      };
    } catch (error) {
      return defaultState();
    }
  }

  let state = loadState();

  function saveState() {
    try {
      localStorage.setItem(STATE_KEY, JSON.stringify(state));
    } catch (error) {
      // Storage can be unavailable in private browsing; popup still works for this page.
    }
  }

  function showPanel(name) {
    panels.forEach((panel) => {
      const isActive = panel.dataset.promoPanel === name;
      panel.classList.toggle('is-active', isActive);
      panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
    activePanel = name;
  }

  function openPopup(name) {
    if (popupOpenedOnPage && !designMode) return;
    showPanel(name);
    popupWrap.classList.add('is-open');
    popupWrap.style.visibility = 'visible';
    popupWrap.style.opacity = '1';
    document.documentElement.classList.add('promo-popup-open');
    popupOpenedOnPage = true;

    const closeButton = popupWrap.querySelector(`[data-promo-panel="${name}"] [data-promo-close]`);
    window.setTimeout(() => closeButton?.focus(), 0);
  }

  function hidePopup() {
    popupWrap.classList.remove('is-open');
    popupWrap.style.visibility = 'hidden';
    popupWrap.style.opacity = '0';
    document.documentElement.classList.remove('promo-popup-open');
  }

  function closePopup() {
    if (!activePanel) return;

    if (!designMode) {
      if (activePanel === 'welcome') {
        state.welcome.dismissedUntil = Date.now() + welcomeDismissMs;
        state.welcome.handledAt = Date.now();
        state.welcome.handledPageView = state.pageViews;
      } else if (activePanel === 'wholesale') {
        state.wholesale.dismissedUntil = Date.now() + wholesaleDismissMs;
      }
      saveState();
    }

    hidePopup();
  }

  function bindCopyButton() {
    const copyBtn = popupWrap.querySelector('[data-copy-target]');
    if (!copyBtn) return;

    copyBtn.addEventListener('click', async () => {
      const target = document.getElementById(copyBtn.dataset.copyTarget);
      if (!target) return;
      const text = target.textContent.trim();

      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(text);
        } else {
          const textarea = document.createElement('textarea');
          textarea.value = text;
          textarea.style.position = 'fixed';
          textarea.style.opacity = '0';
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand('copy');
          textarea.remove();
        }
        copyBtn.classList.add('js-copied');
        window.setTimeout(() => copyBtn.classList.remove('js-copied'), 2500);
      } catch (error) {
        // Keep the code visible so it can still be copied manually.
      }
    });
  }

  popupWrap.querySelectorAll('[data-promo-close]').forEach((element) => {
    element.addEventListener('click', closePopup);
  });

  popupWrap.querySelector('[data-wholesale-visit]')?.addEventListener('click', () => {
    if (designMode) return;
    state.wholesale.completed = true;
    saveState();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && popupWrap.classList.contains('is-open')) {
      closePopup();
    }
  });

  bindCopyButton();

  if (designMode) {
    const panel = ['welcome', 'success', 'wholesale'].includes(previewMode) ? previewMode : 'welcome';
    openPopup(panel);
    return;
  }

  const currentPath = window.location.pathname.replace(/\/$/, '') || '/';
  state.pageViews += 1;

  if (currentPath.startsWith('/pages/wholesale')) {
    state.wholesale.completed = true;
    saveState();
    return;
  }

  if (currentPath === '/cart' || currentPath.startsWith('/checkouts')) {
    saveState();
    return;
  }

  const subscriptionSucceeded = successMarker?.dataset.subscriptionSuccess === 'true';
  const subscriptionFailed = errorMarker?.dataset.subscriptionError === 'true';

  if (subscriptionSucceeded) {
    state.welcome.subscribed = true;
    state.welcome.dismissedUntil = 0;
    state.welcome.handledAt = Date.now();
    state.welcome.handledPageView = state.pageViews;
    try {
      sessionStorage.setItem(SESSION_SUBSCRIBED_KEY, '1');
    } catch (error) {}
    saveState();
    openPopup('success');
    return;
  }

  saveState();

  if (subscriptionFailed) {
    openPopup('welcome');
    return;
  }

  const welcomeEligible = !state.welcome.subscribed && Date.now() >= Number(state.welcome.dismissedUntil || 0);

  if (welcomeEligible) {
    timerId = window.setTimeout(() => openPopup('welcome'), welcomeDelayMs);
    return;
  }

  let subscribedThisSession = false;
  try {
    subscribedThisSession = sessionStorage.getItem(SESSION_SUBSCRIBED_KEY) === '1';
  } catch (error) {}

  if (subscribedThisSession || state.wholesale.completed || !state.welcome.handledAt) return;
  if (Date.now() < Number(state.wholesale.dismissedUntil || 0)) return;

  const additionalPages = state.pageViews - Number(state.welcome.handledPageView || 0);
  if (additionalPages < wholesaleMinPages) return;

  const eligibleAt = Number(state.welcome.handledAt) + wholesaleMinMs;
  const waitMs = Math.max(700, eligibleAt - Date.now());

  timerId = window.setTimeout(() => {
    if (popupOpenedOnPage) return;
    if (Date.now() < Number(state.wholesale.dismissedUntil || 0) || state.wholesale.completed) return;
    state.wholesale.shownCount = Number(state.wholesale.shownCount || 0) + 1;
    saveState();
    openPopup('wholesale');
  }, waitMs);

  window.addEventListener('pagehide', () => {
    if (timerId) window.clearTimeout(timerId);
  });

  if (form) {
    form.addEventListener('submit', function () {
      // Intentionally do not mark the visitor as subscribed here.
      // Subscription state is written only after Shopify returns posted_successfully?.
    });
  }
});